import { useState, useRef, useEffect, useLayoutEffect } from "react"
import CustomEditor from "./CustomEditor"
import { v4 as uuidv4 } from 'uuid';
import Loading from "./Loading";
import "./Components/CSS/CodePlayground.css"

let themes = ['vs-dark', 'active4d', 'all-hallows-eve', 'amy', 'birds-of-paradise', 'blackboard', 'brilliance-black', 'brilliance-dull', 'chrome-devtools', 'clouds-midnight', 'clouds', 'cobalt', 'dawn', 'dreamweaver', 'eiffel', 'espresso-libre', 'github', 'idle', 'katzenmilch', 'kuroir-theme', 'lazy', 'magicwb--amiga-', 'merbivore-soft', 'merbivore', 'monokai-bright', 'monokai', 'night-owl', 'oceanic-next', 'pastels-on-dark', 'slush-and-poppies', 'solarized-dark', 'solarized-light', 'spacecadet', 'sunburst', 'textmate--mac-classic-', 'tomorrow-night-blue', 'tomorrow-night-bright', 'tomorrow-night-eighties', 'tomorrow-night', 'tomorrow', 'twilight', 'upstream-sunburst', 'vibrant-ink', 'xcode-default', 'zenburnesque', 'iplastic', 'idlefingers', 'krtheme', 'monoindustrial']


const CodePlayground = ({code, presetCode, userCode, setOutput, setCode, rightHalfRef }) => {
    const monacoRef = useRef(null)

    const tag = {
        "javascript": "// Code in Javascript",
        "python": "# Code in Python"
    }

    const [language, setLanguage] = useState("python")
    const [fontSize, setFontSize] = useState(18)
    const [theme, setTheme] = useState('vs-dark')  // active4d

    const handleThemeChange = (e) => {
        setTheme(e.target.value)
        monacoRef.current.editor.setTheme(e.target.value)
    }

    const handleFontSizeChange = (e) => {
        setFontSize(e.target.value)
    }

    const handleLanguageChange = (e) => {
        setLanguage(e.target.value)
    }

    return (
        <div ref={rightHalfRef} className="right-half">
            <div className="option-container">
                <select name="languages" id="languages" onChange={handleLanguageChange} style={{background: "#021D36", color: "white", width: "100px", marginRight: "20px", marginLeft: '10px',textAlign: "center", height: '25px', boxSizing: 'border-box'}}>
                <option value="python">Python</option>
                </select>

                <select name="font-size" value={fontSize} id="font-size" onChange={handleFontSizeChange} style={{background: "#021D36", color: "white", width: "100px", marginRight: "20px", textAlign: "center", height: '25px', boxSizing: 'border-box'}}>
                    <option value="14">14px</option>
                    <option value="16">16px</option>
                    <option value="18">18px</option>
                    <option value="20">20px</option>
                    <option value="22">22px</option>
                </select>

                <select name="theme" id="theme" onChange={handleThemeChange} value={theme} style={{background: "#021D36", color: "white", width: "200px", marginRight: "20px", textAlign: "center", height: '25px', boxSizing: 'border-box'}}>
                    {themes.map(theme => <option key={uuidv4()}>{theme}</option>)}
                </select>
            </div>

            {presetCode !== null && userCode !== null ? <CustomEditor language={language} presetCode={presetCode} userCode={userCode} setOutput={setOutput} tag={tag[language]} theme={theme} monacoRef={monacoRef} fontSize={fontSize} setCode={setCode} code={code}></CustomEditor> : <Loading></Loading>}
        </div>
    )
}

export default CodePlayground
